
import { SpinnerVariantProps, spinnerVariants } from 'app/theme/spinner';
import { cn } from 'app/utils/styles.utils';

type SpinnerProps = SpinnerVariantProps;

export const Spinner = ({variant = 'white', size = 'small'}: SpinnerProps) => {
  return <div className={cn(spinnerVariants({variant, size}))} />;
};
